<template>
    <TextArea
        v-if="fieldType.type === 'textarea'"
        :modelValue="modelValue"
        :ariaLabel="label"
        @update:modelValue="onUpdate"
    />
    <TextInput
        v-else-if="fieldType.type === 'text'"
        :modelValue="modelValue"
        :ariaLabel="label"
        @update:modelValue="onUpdate"
        :maxlength="fieldType.params.maxLength"
    />
    <StringListInput
        v-else-if="fieldType.type === 'stringlist'"
        :modelValue="modelValue"
        @update:modelValue="onUpdate"
        :maxItems="fieldType.params.maxItems"
        :maxItemLength="fieldType.params.maxItemLength"
    />
    <ImageListInput
        v-else-if="fieldType.type === 'imagelist'"
        :modelValue="modelValue"
        :maxFiles="fieldType.params.maxFiles"
        @update:modelValue="onUpdate"
    />
    <div
        v-else-if="fieldType.type === 'rating' && field === 'ratings.perceived_size'"
        style="display: flex; gap: var(--gmf-p-3); flex-wrap: wrap;"
    >
        <RadioButton :label="t('comments.perceived_size.small')" :value="1" :modelValue="modelValue" @update:modelValue="onUpdate" :isButton="true" />
        <RadioButton :label="t('comments.perceived_size.normal')" :value="2" :modelValue="modelValue" @update:modelValue="onUpdate" :isButton="true" />
        <RadioButton :label="t('comments.perceived_size.large')" :value="3" :modelValue="modelValue" @update:modelValue="onUpdate" :isButton="true" />
    </div>
    <RatingStars
        v-else-if="fieldType.type === 'rating'"
        :isInput="true"
        :type="fieldType.params.ratingType"
        :rating="modelValue || 0"
        @update:modelValue="onUpdate"
    />
    <DropdownSelect v-else-if="fieldType.type === 'select'"
        :modelValue="modelValue"
        @update:modelValue="onUpdate"
        :options="fieldType.params.options"
        :placeholder="fieldType.params.placeholder"
    />
    <ProductListInput v-else-if="fieldType.type === 'productlist'"
        :modelValue="modelValue"
        @update:modelValue="onUpdate"
    />
    <span v-else>Unknown field type {{ fieldType.type }}</span>
</template>

<script>
import state from '@/state';
const t = state.t;
import TextArea from '@/components/input/TextArea.vue';
import TextInput from '@/components/input/TextInput.vue';
import StringListInput from '@/components/input/StringListInput.vue';
import ImageListInput from '@/components/input/ImageListInput.vue';
import RatingStars from '@/components/RatingStars.vue';
import DropdownSelect from '@/components/DropdownSelect.vue';
import RadioButton from '@/components/input/RadioButton.vue';
import ProductListInput from '@/components/input/ProductListInput.vue';

export default {
    components: {
        TextArea,
        TextInput,
        StringListInput,
        ImageListInput,
        RatingStars,
        DropdownSelect,
        RadioButton,
        ProductListInput,
    },
    props: {
        field: {
            type: String,
            required: true,
        },
        modelValue: {},
        fieldType: {
            type: Object,
            required: true,
        },
        commentType: {
            type: String,
            required: true,
        },
    },
    methods: {
        t,
        onUpdate(value) {
            this.$emit('update:modelValue', value);
        },
    },
    computed: {
        label() {
            return t('comments.form_v2.' + this.commentType + '.' + this.field + '.title') || t('comments.form_v2.default.' + this.field + '.title');
        },
    },
}
</script>